import React from 'react';
import classNames from 'classnames';

import circleChecked from 'assets/icons/circle-check.svg';
import circleCrossed from 'assets/icons/circle-remove.svg';

interface BooleanIconProps {
  value: boolean;
  className?: string;
  trueAlt?: string;
  falseAlt?: string;
}

const BooleanIcon = ({
  value,
  className,
  trueAlt = 'trueAlt',
  falseAlt = 'falseAlt'
}: BooleanIconProps) => (
  <div className={classNames(className)}>
    {value && <img src={circleChecked} alt={trueAlt} />}
    {!value && <img src={circleCrossed} alt={falseAlt} />}
  </div>
);

export default BooleanIcon;
